import { PlaceHolder } from "@/services/smsPlaceHolders/type";

const replacePlaceholders = (
  text: string,
  tags: PlaceHolder[],
  preview?: boolean
) => {
  let result = text;
  for (const tag of tags) {
    const regex = new RegExp(tag.key || "", "g");
    const previewValue = preview
      ? tag?.preView
        ? tag.preView
        : `${tag.value} (مقدار توسط شما وارد نشده است)`
      : tag.preView
      ? tag.value
      : `${tag.value} (مقدار توسط شما وارد نشده است)`;
    const backgroundColor =
      !tag.value || !tag?.preView
        ? "var(--mantine-color-red-5)"
        : "var(--mantine-color-gray-5)";
    const styledLabel = `<span class="tag" style="background: ${backgroundColor}; padding: 1px 5px 1px 5px; color: white; border-radius: 5px;">${previewValue}</span>`;
    result = result.replace(regex, styledLabel);
  }
  return result;
};
export default replacePlaceholders;
